import { NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AbpHttpInterceptor } from 'abp-ng2-module';

import * as ApiServiceProxies from './service-proxies';
import { ArrayToTreeConverterService } from './array-to-tree-converter.service';
import { TreeDataHelperService } from './tree-data-helper.service';

@NgModule({
    providers: [
        ApiServiceProxies.RoleServiceProxy,
        ApiServiceProxies.SessionServiceProxy,
        ApiServiceProxies.TenantServiceProxy,
        ApiServiceProxies.UserServiceProxy,
        ApiServiceProxies.TokenAuthServiceProxy,
        ApiServiceProxies.AccountServiceProxy,
        ApiServiceProxies.ConfigurationServiceProxy,
        ApiServiceProxies.LookupServiceProxy,
        ApiServiceProxies.CustomerOfficeServiceProxy,
        ApiServiceProxies.CompanyServiceProxy,
        ApiServiceProxies.DivisionServiceProxy,
        ApiServiceProxies.SalesPersonServiceProxy,
        ApiServiceProxies.RepairCategoryServiceProxy,
        ApiServiceProxies.RepairSizeServiceProxy,
        ApiServiceProxies.RepairServiceProxy,
        ApiServiceProxies.RepairTypeServiceProxy,
        ApiServiceProxies.DamageTypeServiceProxy,
        ApiServiceProxies.DamageTypeRepairCategoryServiceProxy,
        ApiServiceProxies.CurrencyServiceProxy,
        ApiServiceProxies.BaseAccessoryServiceProxy,
        ApiServiceProxies.EquipmentTypeServiceProxy,
        ApiServiceProxies.PerformanceReportsServiceProxy,
        ApiServiceProxies.StandardIndustrialRefServiceProxy,
        ApiServiceProxies.FactorTypeServiceProxy,
        ApiServiceProxies.WOCheckSheetItemsCannedNotesServiceProxy,
        ApiServiceProxies.VideoOutPutServiceProxy,
        ApiServiceProxies.ServiceLabServiceProxy,
        ApiServiceProxies.ManufacturerServiceProxy,
        ApiServiceProxies.ModelGroupServiceProxy,
        ApiServiceProxies.ModelGroupFieldListDataServiceProxy,
        ApiServiceProxies.ModelServiceProxy,
        ApiServiceProxies. ModelDocumentsServiceProxy,
        ApiServiceProxies. TestEquipmentCommonNameServiceProxy,
        ApiServiceProxies. TestEquipmentManufacturersServiceProxy,
        ApiServiceProxies. TestEquipmentsModelServiceProxy,
        ApiServiceProxies. TestEquipmentLocationServiceProxy,
        ApiServiceProxies. ModelRepairsListServiceProxy,
        ApiServiceProxies. EquipmentsServiceProxy,
        ApiServiceProxies.BranchServiceProxy,
        ArrayToTreeConverterService,
        TreeDataHelperService,
        ApiServiceProxies.DepartmentServiceProxy,
        ApiServiceProxies.ModelGroupDepartmentServiceProxy,
        ApiServiceProxies.ModelGroupTechnicalFieldsServiceProxy,
        ApiServiceProxies.PartServiceProxy,
        ApiServiceProxies.UomServiceProxy,
        ApiServiceProxies.CommonDefectsServiceProxy,
        ApiServiceProxies.PayCycleServiceProxy,
        ApiServiceProxies.DivertibleDepartmentServiceProxy,
        ApiServiceProxies.CheckSheetServiceProxy,
        ApiServiceProxies.PartNameAliasServiceProxy,
        ApiServiceProxies.PackageTypeServiceProxy,
        ApiServiceProxies.AdjustmentServiceProxy,
        ApiServiceProxies.CustomerDefectServiceProxy,
        ApiServiceProxies.DiscountLevelServiceProxy,
        ApiServiceProxies.DefectCategoryServiceProxy,
        ApiServiceProxies.DefectReasonServiceProxy,
        ApiServiceProxies.DefectLocationServiceProxy,
        ApiServiceProxies.DefectCategoriesReasonServiceProxy,
        ApiServiceProxies.DefectCategoryReasonsRepairServiceProxy,
        ApiServiceProxies.CostTypeServiceProxy,
        ApiServiceProxies.ModelServiceProxy,
        ApiServiceProxies.ModelPartsListServiceProxy,
        ApiServiceProxies.ServiceTypeServiceProxy,
        ApiServiceProxies.ShipmentCodeServiceProxy,
        ApiServiceProxies.CarrierServiceProxy,
        ApiServiceProxies.CustomerDepartmentServiceProxy,
        ApiServiceProxies.CustomerTypeServiceProxy,
        ApiServiceProxies.VendorServiceProxy,
        ApiServiceProxies.DepotSubContractorServiceProxy,
        ApiServiceProxies.DepotSubContractorAddressServiceProxy,
        ApiServiceProxies.SubContractorServiceProxy,
        ApiServiceProxies.StateServiceProxy,
        ApiServiceProxies.RegionServiceProxy,
        ApiServiceProxies.PriorityCodeServiceProxy,
        ApiServiceProxies.ContractServiceProxy,
        ApiServiceProxies.DepartmentGroupServiceProxy,
        ApiServiceProxies.FacilityServiceProxy,
        ApiServiceProxies.LoanerAgreementServiceProxy,
        ApiServiceProxies.WorkOrderServiceProxy,
        ApiServiceProxies.PricingLookupServiceProxy,
        ApiServiceProxies.DepotSubContracterPOViewServiceProxy,
        ApiServiceProxies.EmailServiceProxy,
        ApiServiceProxies.QuotationServiceProxy,
        ApiServiceProxies.CustomerDashboardServiceProxy,
        ApiServiceProxies.InvoiceServiceProxy,
        ApiServiceProxies.CertifyCompletionServiceProxy,
        ApiServiceProxies.SalespersonDashboardServiceProxy,
        ApiServiceProxies.TechnicalReportServiceProxy,
        ApiServiceProxies.WorkOrderReportsServiceProxy,
        ApiServiceProxies.WorkOrderDashboardServiceProxy,
        ApiServiceProxies.DepotPOServiceProxy,
        { provide: HTTP_INTERCEPTORS, useClass: AbpHttpInterceptor, multi: true },
    ],
})
export class ServiceProxyModule {}
